import { atom } from 'jotai';

export const atomFromEnv = <T,>(key: string, defaultValue: T) => {
  return atom<T>(() => import.meta.env[key] ?? defaultValue);
};
